<script lang="ts">
  import { page } from '$app/stores';

  $: configurations = $page.data.configurations;
  $: locations = configurations.locations ? configurations.locations[0] : null;
</script>

<section>
  <div class="text-base">
    <p class="text-dark-700 mb-6">Contacts</p>

    <p class="text-dark-700">Address:</p>

    {#if locations}
      <p class="mb-5 inline-block">
        {locations.country.value},
        {#if locations.city}
          {locations.city.value}
        {/if}
        <br />
        {#if locations.address}
          {locations.address}
        {/if}
      </p>
    {/if}

    {#if configurations.contacts}
      {#each configurations.contacts as contact}
        {@const href = contact.type === 'email' ? `mailto:${contact.value}` : `tel:${contact.value}`}

        <div>
          <span class="text-dark-700 capitalize">{contact.type}: </span>

          <a
            {href}
            class="underline-hover after:bg-default-400 dark:after:bg-default-500 border-b after:absolute after:-bottom-[1px] after:left-0 after:right-0 after:h-[1px]"
          >
            {contact.value}
          </a>
        </div>
      {/each}
    {/if}
  </div>
</section>
